import React from "react";
import styles from "./PromoMaterials.module.scss";

const PromoControls = ({ format, onFormatChange, onDownloadAll, downloading }) => {
  return (
    <div className={styles.controls}>
      <div className={styles.formatGroup}>
        <span style={{ fontSize: 14, fontWeight: 500, color: "#333" }}>Format:</span>
        <label>
          <input
            type="radio"
            name="format"
            value="png"
            checked={format === "png"}
            onChange={() => onFormatChange("png")}
          />
          PNG
        </label>
        <label>
          <input
            type="radio"
            name="format"
            value="jpg"
            checked={format === "jpg"}
            onChange={() => onFormatChange("jpg")}
          />
          JPG
        </label>
      </div>
      <button
        className={styles.downloadAllBtn}
        onClick={onDownloadAll}
        disabled={downloading}
      >
        {downloading ? "Generating ZIP..." : "Download All (ZIP)"}
      </button>
    </div>
  );
};

export default PromoControls;
